class MFRHowMimioWorks {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      button: ".how-mimio-works__nav li button",
      image: ".how-mimio-works__items-image",
      carousel: ".carousel__slides"
    };

    this.init();
  }

  init() {
    this.$button = this.$element.find(this.selectors.button);
    this.$image = this.$element.find(this.selectors.image);
    this.$carousel = this.$element.find(this.selectors.carousel);

    this.$button.on("click", this.__handleButtonClick.bind(this));
  }

  __handleButtonClick(e) {
    if ($(e.currentTarget).hasClass("is-active")) return;
    const index = $(e.currentTarget).data( "index" );

    this.$button.removeClass("is-active");
    $(e.currentTarget).addClass("is-active");

    this.$image.removeClass("is-active");
    this.$image.eq(index).addClass("is-active");

    this.$carousel.flickity( "selectCell", index );
  }
}